export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8286.a7a0c166.jpg";